import { useSelector } from 'react-redux';

import { API, useFetch } from 'app/api';

import { getFreshchatConfig } from '../site-configs/selectors';

export const useFreshchatConfig = () => {
  const freshchatConfig = useSelector(getFreshchatConfig);

  const { makeRequest: saveRestoreId } = useFetch(
    API.freshChat.sendFreshChatRestoreId,
    { skipSSR: true },
  );

  return {
    token: freshchatConfig?.freshchatToken,
    widgetUuid: freshchatConfig?.freshchatUuid,
    host: freshchatConfig?.freshchatHost,
    saveRestoreId,
    config: {
      headerProperty: {
        hideChatButton: true,
      },
    },
  };
};
